import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InnerSection } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import Button from 'components/input/Button';
import LocalizeEditor from 'components/input/LocalizeEditor';
import TermsContainer from 'containers/TermsContainer';

const CheckoutInfoPage = () => {
  const title = {
    ko: '이용안내 작성',
    en: 'Usage Information',
    ja: '利用規約',
    zh: '使用条款',
  };
  return (
    <PageLayout title="이용안내 작성">
      <TermsContainer type="USAGE" title={title} />
    </PageLayout>
  );
};

export default CheckoutInfoPage;
